<template>
  <RCard class="invoices">
    <AgGrid ref="agGrid" :options="gridOptions" :row-data="invoices" title="Invoices" @cell-value-changed="cellUpdated">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2">Invoices</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
// Mixins
import { gridOptions } from './gridOptions'
// Libraries
import { cloneDeep, get, isEqual } from 'lodash'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [gridOptions],

  inject: ['getInvoices', 'modifyInvoice'],

  data: () => ({
    invoices: null
  }),

  created() {
    this.getAndSetInvoices()
  },

  methods: {
    getAndSetInvoices() {
      this.getInvoices().then(({ data }) => {
        this.invoices = data.result
      })
    },

    getPayload(field, newValue) {
      if (field.includes('vendor_payment')) {
        const vendorField = field.split('.')[1]
        return {
          vendor_payment: { [vendorField]: newValue }
        }
      }
      return { [field]: newValue }
    },

    cellUpdated({ newValue, column, oldValue, colDef: { field }, data, data: { id } }) {
      const newVal = cloneDeep(newValue) || null
      const oldVal = cloneDeep(oldValue) || null
      if (isEqual(newVal, oldVal)) return

      let newValueForBE = get(data, column.colId)
      const datesFields = ['issue_date', 'due_date', 'vendor_payment.payment_date']
      if (datesFields.includes(field)) {
        newValueForBE = this.formatDateForPost(newValueForBE)
      }

      this.modifyInvoice(id, this.getPayload(field, newValueForBE)).finally(this.getAndSetInvoices)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.invoices {
  @include table-with-no-filters;
}
</style>
